import $ from 'jquery';

$( document ).ready(function() {
	$('#cp-svg').find('.cp-section-group').hover(
		function() {
			if(this.id === 'one-eighth') {
				$('.content').each(function(){
					if($(this).attr('data-section') === '1' ) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}

					if($(this).attr('data-section') === '1' ) {
						$('.one-eighth').toggleClass('cp-icon');
					}
				});
			} else if(this.id === 'two-eighth') {
				$('.content').each(function(){
					if($(this).attr('data-section') === '2' ) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
					if($(this).attr('data-section') === '2' ) {
						$('.two-eighth').toggleClass('cp-icon');
					}
				});
			} else if(this.id === 'three-eighth') {
				$('.content').each(function(){
					if($(this).attr('data-section') === '3' ) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
					if($(this).attr('data-section') === '3' ) {
						$('.three-eighth').toggleClass('cp-icon');
					}
				});
			} else if(this.id === 'four-eighth') {
				$('.content').each(function(){
					if($(this).attr('data-section') === '4' ) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
					if($(this).attr('data-section') === '4' ) {
						$('.four-eighth').toggleClass('cp-icon');
					}
				});
			} else if(this.id === 'five-eighth') {
				$('.content').each(function(){
					if($(this).attr('data-section') === '5' ) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
					if($(this).attr('data-section') === '5' ) {
						$('.five-eighth').toggleClass('cp-icon');
					}
				});
			} else if(this.id === 'six-eighth') {
				$('.content').each(function(){
					if($(this).attr('data-section') === '6' ) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
					if($(this).attr('data-section') === '6' ) {
						$('.six-eighth').toggleClass('cp-icon');
					}
				});
			} else if(this.id === 'seven-eighth') {
				$('.content').each(function(){
					if($(this).attr('data-section') === '7' ) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
					if($(this).attr('data-section') === '7' ) {
						$('.seven-eighth').toggleClass('cp-icon');
					}
				});
			} else if(this.id === 'whole-eighth') {
				$('.content').each(function(){
					if($(this).attr('data-section') === '8' ) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
					if($(this).attr('data-section') === '8' ) {
						$('.whole-eighth').toggleClass('cp-icon');
					}
				});
			}
		}
	);
});
